// extracted by mini-css-extract-plugin
module.exports = {"input":"Input_input__1-JT-","wrapper":"Input_wrapper__3g9B2","label":"Input_label__FTf6d"};